import {ShippingOption} from "./ShippingOption";

export class ShippingPackage {
  /** Default packing cost per book when the server does not provide one. */
  static readonly DEFAULT_PACKING_COST_PER_BOOK = 0.10;

  height: number;
  width: number;
  depth: number;
  weight: number;
  quantity: number;
  /**
   * Number of items (books) packed in a single instance of this package.
   * Set by the server when known so per-book packing cost can be computed.
   * If unset, callers fall back to a per-book default (see `getPackingCost`).
   */
  itemsPerPackage: number;
  /**
   * Per-package packing/packaging cost in dollars. When unset (server has not
   * yet returned a cost) callers should fall back to a per-book default.
   */
  packingCost: number;
  /**
   * Server-side identifier for the package type used (corresponds to
   * `printnode_packagetype.ID`). Populated by `POST order/rateshipping` (S-3);
   * absent on packages returned by the legacy two-call shipping flow.
   */
  packageTypeId?: number;
  /**
   * Zero-based index of this package within its parent package-set's
   * `packages[]` array, returned by `POST order/rateshipping`. Used to align
   * a rate row's `perPackageCosts[i]` back to the package it describes.
   */
  packageIndex?: number;
  status = 'INITIAL';
  computationVersion: number;
  shippingOptions: ShippingOption[] = [];
  computationStatus = 'DIRTY';

  constructor ( height: number, width: number, depth: number, weight: number, quantity: number, shippingOptions: ShippingOption[], itemsPerPackage?: number, packingCost?: number, packageTypeId?: number, packageIndex?: number ) {
    this.height = height;
    this.width = width;
    this.depth = depth;
    this.weight = weight;
    this.quantity = quantity;
    this.shippingOptions = shippingOptions;
    this.itemsPerPackage = itemsPerPackage;
    this.packingCost = packingCost;
    this.packageTypeId = packageTypeId;
    this.packageIndex = packageIndex;
  }

  getCost(carrier: string, serviceLevel: string ) {
    for ( const shippingOption of this.shippingOptions ) {
      if ( shippingOption.carrier === carrier && shippingOption.serviceLevel === serviceLevel ) {
        return shippingOption.cost * (this.quantity || 1);
      }
    }
    return -1;
  }

  /**
   * Total packing/packaging cost across all instances of this package
   * (this.quantity copies). Falls back to
   * `DEFAULT_PACKING_COST_PER_BOOK * itemsPerPackage * quantity` when no
   * `packingCost` is supplied by the server.
   *
   * Guards against `quantity === undefined` (the wire spec makes
   * `quantity` optional and some packer responses omit it) so a
   * missing quantity doesn't propagate NaN through the cart's
   * unified-choice totals — a NaN there caused the whole shipping
   * picker to render with blank cost columns.
   */
  getPackingCost(): number {
    const qty = this.quantity || 1;
    if (this.packingCost !== undefined && this.packingCost !== null) {
      return this.packingCost * qty;
    }
    const itemsPer = this.itemsPerPackage > 0 ? this.itemsPerPackage : 1;
    return ShippingPackage.DEFAULT_PACKING_COST_PER_BOOK * itemsPer * qty;
  }

  setShippingOptions(shippingOptions) {
    this.shippingOptions = shippingOptions;
  }
}



